import { createContext } from 'react';
const BidsContext = createContext({
  confirmSectionType: '',
});
export default BidsContext;
